import PropTypes from 'prop-types';

export const groupsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        icon: PropTypes.elementType,
        // Role permission and account module; both must pass when both are set (useNavItemAccess).
        permission: PropTypes.string,
        module: PropTypes.string,
      }),
    ).isRequired,
  }),
);

export const badgesPropType = PropTypes.objectOf(
  PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    tone: PropTypes.oneOf(['neutral', 'warn']),
  }),
);

// Group-level badge (rendered next to the group label) — supports an optional leading icon.
export const groupBadgesPropType = PropTypes.objectOf(
  PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    tone: PropTypes.oneOf(['neutral', 'warn']),
    icon: PropTypes.elementType,
  }),
);
